module.exports = __webpack_public_path__ + "img/sky.425bdb0c.png";